import { useEffect, useState } from "react";
import { getToken } from "firebase/messaging";
import { messaging } from "../firebase";
import 'bootstrap-icons/font/bootstrap-icons.css';
import api from "../services/api";

const NotificationPrompt = () => {
  const [showModal, setShowModal] = useState(false);
  const [showBell, setShowBell] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // 1. حماية: التأكد إن المتصفح بيدعم الإشعارات
    if (!("Notification" in window)) {
      console.warn("This browser does not support desktop notifications.");
      return;
    }

    const browserStatus = Notification.permission;
    const localStatus = localStorage.getItem("notif_status");
    const sessionStatus = sessionStorage.getItem("notif_status");

    // ==========================================
    // 🚀 هندلة تغيير الإعدادات يدوياً (المزامنة الصامتة)
    // ==========================================
    
    // حالة 1: فعلها من الإعدادات بس إحنا مش مسجلين ده عندنا
    if (browserStatus === "granted" && localStatus !== "granted") {
      silentTokenSync();
      return; // نوقف الكود هنا عشان مفيش نوافذ تظهر
    }
    
    // حالة 2: قفلها من الإعدادات بس إحنا مسجلين إنها شغالة
    if (browserStatus === "denied" && localStatus !== "denied") {
      localStorage.setItem("notif_status", "denied");
      return;
    }

    // حالة 3: لو كله تمام واليوزر واخد قرار ومسجلينه (سواء موافق أو رافض)
    if (localStatus === "granted" || localStatus === "denied") {
      return;
    }

    // ==========================================
    // 🔔 عرض النوافذ لو اليوزر لسه مخدش قرار
    // ==========================================
    if (browserStatus === "default") {
      if (sessionStatus === "later") {
        setShowBell(true);
      } else {
        setShowModal(true);
      }
    }
  }, []);

  // دالة المزامنة الصامتة (بتشتغل في الخلفية بدون علم اليوزر)
  const silentTokenSync = async () => {
    try {
      const token = await getToken(messaging, {
        vapidKey: "BHTyku3YwSTovCOVHRvOKFp5fQDgPgiH6lMiLRwfMe6_XC_Y3Cx-2J51kF0yNxME8Znrd59ROOqDBBI9E7l02tc"
      });
      
      // إرسال التوكن للباك إند
      await api.post("/Users/save-fcm-token", { fcmToken: token });
      console.log("✅ Silent Token Sync Successful!");
      
      // تحديث الذاكرة عشان ميعملش ريكويست تاني مع الـ Refresh
      localStorage.setItem("notif_status", "granted");
      sessionStorage.removeItem("notif_status");
      
    } catch (error) {
      console.error("❌ Silent Sync failed:", error);
    }
  };

  const enableNotifications = async () => {
    setIsLoading(true);
    try {
      const permission = await Notification.requestPermission();

      if (permission === "granted") {
        const token = await getToken(messaging, {
          vapidKey: import.meta.env?.VITE_VAPID_KEY || "BHTyku3YwSTovCOVHRvOKFp5fQDgPgiH6lMiLRwfMe6_XC_Y3Cx-2J51kF0yNxME8Znrd59ROOqDBBI9E7l02tc"
        });

        console.log("🔥 FCM TOKEN:", token);

        try {
          await api.post("/Users/save-fcm-token", { fcmToken: token });
          console.log("✅ FCM Token saved to database successfully!");
        } catch (apiError) {
          console.error("❌ Failed to save token to backend:", apiError);
        }

        localStorage.setItem("notif_status", "granted");
        sessionStorage.removeItem("notif_status");
        setShowModal(false);
        setShowBell(false);
        
      } else {
        localStorage.setItem("notif_status", "denied");
        setShowModal(false);
        setShowBell(false);
      }
    } catch (err) {
      console.error("Error getting notification token:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const dismiss = () => {
    sessionStorage.setItem("notif_status", "later");
    setShowModal(false);
    setShowBell(true);
  };

  if (!showModal && !showBell) return null;

  return (
    <>
      <style>
        {`
          @keyframes pulse-ring {
            0% { transform: scale(0.8); box-shadow: 0 0 0 0 rgba(25, 135, 84, 0.5); }
            70% { transform: scale(1); box-shadow: 0 0 0 12px rgba(25, 135, 84, 0); }
            100% { transform: scale(0.8); box-shadow: 0 0 0 0 rgba(25, 135, 84, 0); }
          }
          .floating-bell {
            animation: pulse-ring 2s infinite;
            transition: all 0.3s ease;
          }
          .floating-bell:hover {
            transform: scale(1.1) !important;
            animation: none;
          }
        `}
      </style>

      {showBell && !showModal && (
        <div
          onClick={() => {
            setShowBell(false);
            setShowModal(true);
          }}
          className="position-fixed bottom-0 end-0 m-4 shadow d-flex align-items-center justify-content-center bg-primary rounded-circle floating-bell"
          style={{
            width: "55px",
            height: "55px",
            cursor: "pointer",
            zIndex: 9998,
          }}
          title="Enable Notifications"
        >
          <i className="bi bi-bell-fill text-white" style={{ fontSize: "1.8rem" }}></i>
        </div>
      )}

      {showModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
            zIndex: 9999,
          }}
        >
          <div
            className="card border-0 p-4 text-center shadow-lg"
            style={{
              maxWidth: "400px",
              width: "90%",
              borderRadius: "24px",
              background: "rgba(255, 255, 255, 0.85)",
              backdropFilter: "blur(16px)",
              WebkitBackdropFilter: "blur(16px)",
              border: "1px solid rgba(255, 255, 255, 0.5)",
            }}
          >
            <div className="mb-3 d-flex justify-content-center">
              <div
                className="d-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: "64px",
                  height: "64px",
                  background: "rgba(25, 135, 84, 0.1)",
                }}
              >
                <i className="bi bi-bell-fill text-success" style={{ fontSize: "2rem" }}></i>
              </div>
            </div>

            <h4 className="fw-bolder mb-2 text-dark">Stay Updated!</h4>

            <p
              className="text-muted mb-4 px-2"
              style={{ fontSize: "0.95rem", lineHeight: "1.6" }}
            >
              Enable notifications to get instant updates about new activities and approvals.
            </p>

            <div className="d-flex flex-column gap-3">
              <button
                onClick={enableNotifications}
                disabled={isLoading}
                className="btn btn-success fw-bold py-2 rounded-pill shadow-sm d-flex align-items-center justify-content-center gap-2"
                style={{ transition: "all 0.3s ease" }}
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Processing...
                  </>
                ) : (
                  "Enable Notifications"
                )}
              </button>

              <button
                onClick={dismiss}
                disabled={isLoading}
                className="btn btn-light fw-semibold py-2 rounded-pill text-secondary"
                style={{
                  background: "transparent",
                  border: "none",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) =>
                  (e.target.style.background = "rgba(0,0,0,0.05)")
                }
                onMouseOut={(e) =>
                  (e.target.style.background = "transparent")
                }
              >
                Maybe Later
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NotificationPrompt;

